import * as React from "react";
import useProductName from "brand-customization/useProductName";
import { Alert } from "components/bootstrap";
import LicenseHelp from "license/notifications/LicenseHelp";
const LicenseViolationNotification = () => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", className: "has-bm", title: `${productName} License Violation` }, /* @__PURE__ */ React.createElement("p", null, "At least one term of your ", productName, " license has been violated. ", /* @__PURE__ */ React.createElement(LicenseHelp, null)));
};
export default LicenseViolationNotification;
